import React from "react";
import { Link } from "react-router-dom";

const ServicesCard = (props) => {
  return (
    <div className="col-xl-4 col-md-6 col-12 revamp-reveal">
        <div className="revamp-service-card">
            <div className="thumb" style={{backgroundImage: `url(${props.bgImgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}}></div>
            <div className="content">
                <h3><Link to="/contact">{props.caption}</Link></h3>
            </div>
        </div>
    </div>
  );
};

export default ServicesCard;